import { render, staticRenderFns } from "./GenericPrivacyVoodoo.vue?vue&type=template&id=7e6bd0e0&scoped=true"
import script from "./GenericPrivacyVoodoo.vue?vue&type=script&lang=js"
export * from "./GenericPrivacyVoodoo.vue?vue&type=script&lang=js"
import style0 from "./GenericPrivacyVoodoo.vue?vue&type=style&index=0&id=7e6bd0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6bd0e0",
  null
  
)

export default component.exports